import {
  NetworkStatus,
  useNetworkStatus,
} from "$global-providers/network-status-provider/provider";
import type { AncEncountersQuery } from "$routes/patient/[:patientId]/antenatal-care/_lib/__generated__/anc-encounters.gql";
import { useAncEncountersQuery } from "$routes/patient/[:patientId]/antenatal-care/_lib/__generated__/anc-encounters.gql";
import { shouldShowAncVisitsTab } from "./should-show-anc-visits-tab";

export type AncVisitForTab =
  AncEncountersQuery["ancEncounters"]["encounters"][0];

type Result = {
  shouldShow: boolean;
  encounters: AncVisitForTab[];
  loading: boolean;
};

export function useAncVisitsTabVisibility(patientId: string): Result {
  const isOffline = useNetworkStatus().networkStatus === NetworkStatus.OFFLINE;
  const { data, loading } = useAncEncountersQuery({
    variables: {
      input: { params: { patientId, searchWholeTerritory: true } },
    },
    skip: isOffline,
  });

  const encounters = (data?.ancEncounters?.encounters ?? []).filter(
    (e): e is AncVisitForTab => e != null,
  );

  return {
    shouldShow: !isOffline && shouldShowAncVisitsTab(encounters),
    encounters,
    loading,
  };
}
